export const FirebaseConfig = {
	"projectId": "corrida-facil-1495645247963",
	"appId": "1:37215785957:web:167a2a65415f30eb79150c",
	"databaseURL": "https://corrida-facil-1495645247963.firebaseio.com",
	"storageBucket": "corrida-facil-1495645247963.firebasestorage.app",
	"locationId": "us-central",
	"apiKey": "AIzaSyDAOkD6V88D4spC6IxuLIVgeVcfHeyi9R4",
	"authDomain": "corrida-facil-1495645247963.firebaseapp.com",
	"messagingSenderId": "37215785957",
	"measurementId": "G-QWG5F0ZZ6W"
};